import { Breadcrumb, PageTitle, Toolbar } from "components";
import { MainContainer } from "pages/Main";
import React, { PureComponent } from "react";
import { Col, Row } from "react-bootstrap";
import CardClass from "./CardClass/CardClass";
import TableClass from "./TableClass/TableClass";
import TableSubjects from "./TableSubjects/TableSubjects";
import * as util from "services/util";
import {
  withApiContext,
  withLabelsContext,
  withUserContext,
  withWindowContext,
} from "context";
import moment from "moment";
import * as messages from "messages";
import { withRouter } from "react-router-dom";
import * as config from 'config';
import jsPDF from "jspdf";

class MyClasses extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isExpired: 0,
      displayType: "overview",
      ownClasses: {},
      selectedOwnClassId: null,
      classSubjects: {},
      selectedClassSubjectId: null,
      selectedClassSubjectActive: false,
      selectedOwnClassActive: false,
      classIds: [],
      loading: false,
      loadingInteraction: false,
      activeMenu: "menu1",
      stepsEnabled: false,
      initialStep: 0,
      isOpen: false,
      searching: false,
      classData: [],
      page: 1,
      perPage: 5, 
      sortColumn: 'default',
      sortDirection: 'asc',
      totalCount: 0, 
      viewType : "open",
      filter: "",

      steps: [
        {
          intro: "My class card",
          element: ".intro-my-class",
        },
        {
          intro: "My subject class",
          element: ".intro-subject-class",
        },
      ],

      // hideDisplay: true,
    };

    if (props.classSubId) {
      this.setState({ selectedClassSubjectId: props.classSubId });
    }
  }

  componentDidMount = () => {
    if (this.props.ctx_user.user.type === 2) {
      this.loadMyClassData();
      this.loadClassSubjectData();
    } else {
      this.loadClassData();
    }
  };
  expiredCourses = (value) => {
    this.setState({ isExpired: value, searching:true }, () => {
        this.loadClassSubjectData();
    });
}
filterChange = (value) => {
  this.setState({ filter: value, searching:true }, () => {
    this.loadClassSubjectData();
});
}
  loadMyClassData = () => {
    const args = {
        teacherId: this.props.ctx_user.user.id,
        acadYearId: this.props.ctx_user.user.acadYearId,
      };
      this.props.ctx_api
      .privateRequest({ cmd: "get_teacher_class", args: args })
      .then((data) => {
        const ownClasses = this.extractLoadOwnClassResponse(data);
        this.setState({ ownClasses });
      })
      .catch(this.handleDashboardSystemFailure);

  }
  loadClassSubjectData = (page, newPerPage, sortColumn, sortDirection) => {
    //const courseType = this.state.viewType === "open" ? 0 : 1
    this.setState({ searching:true})
    const args = {
      teacherId: this.props.ctx_user.user.id,
      acadYearId: this.props.ctx_user.user.acadYearId,
      pageSize:  newPerPage || this.state.perPage,
      pageIndex:  page || this.state.page,
      sortColumn: sortColumn || this.state.sortColumn,
      sortOrder: sortDirection || this.state.sortDirection,
      isExpired:this.state.isExpired
     //filter: this.state.filter
      //courseType : courseType || this.state.courseType
    };
    if (this.state.filter) {

      args.filter = this.state.filter;}
    this.props.ctx_api
      .privateRequest({ cmd: "get_teacher_classes", args: args })
      .then((data) => {
        if(data.rsp[0] != undefined){
        const classSubjects = data.rsp[0] == undefined ? [] : this.extractLoadClassSubjectsResponse(data);
        const totalCount = data.rsp[0] == undefined ? 0 : data.rsp[0].total_count;
        this.setState({ classSubjects, totalCount, searching: false});
        }
        else{
          this.setState({searching:false})
        }
        
      })
      .catch(this.handleDashboardSystemFailure);
  };

  loadClassData = () => {
    const { location } = this.props;
    const id = location.data?.id;
    const newId = location.data?.classId;
    this.props.ctx_api
      .privateRequest({
        cmd: "get_trainer_class_course_publish_details",
        args: {
          classId: location.state?.fromClassPerformance ? location.state.classId : id ? id : newId,
        },
      })
      .then(({ rsp }) => {
        const interactionData = rsp.map((row) => {
          return {
            ...row,
            publishedFrom: moment(row.published_from).format("MMM DD, YYYY"),
            publishedTo: moment(row.published_to).format("MMM DD, YYYY"),
          };
        });
        const data = {
          className: location.alternateEntry?.name,
          interaction: interactionData,
        };
        this.setState({ classData: data });
      });
  };

  handleDashboardSystemFailure = (err) => {
    console.log(err);
  };

  extractLoadOwnClassResponse = ({ rsp }) => {
    const items = {};
    rsp.forEach((row) => {
      const item = {
        id: row.class_id,
        className: row.class_name,
        classShortName: row.class_shortname,
        completionPercentage: row.completion_percentage,
        avgTestPercentage: row.avg_test_percentage,
        noTraniees: row.no_of_traniees,
      };
      items[row.class_id] = item;
    });
    return items;
  };

  extractLoadClassSubjectsResponse = ({ rsp }) => {
    const items = {};
    rsp[0].selection.forEach((row) => {
      const item = {
        id: row.class_id + "-" + row.curriculum_id,
        name: row.classname + " - " + row.currname,
        publishedFrom: moment(row.start_date).format("MMM DD , YYYY"),
        publishedTo: moment(row.end_date).format("MMM DD , YYYY"),
        ...row,
      };
      items[row.class_id + "-" + row.curriculum_id] = item;
    });
    return items;
  };

  handleClickOwnClass = async (id) => {
    const { ownClasses } = this.state;
    this.setState((s0) => {
      return { isOpen: !s0.isOpen };
    });

    if (!ownClasses[id].interaction) {
      this.setState({ loadingInteraction: true });
      const args = {
        classId: id, // change
      };
      const { rsp } = await this.props.ctx_api.privateRequest({
        cmd: "get_trainer_class_course_publish_details",
        args,
      });
      this.setState({ loadingInteraction: false });
      const interactionData = rsp.map((row) => {
        return {
          ...row,
          publishedFrom: moment(row.published_from).format("MMM DD, YYYY"),
          publishedTo: moment(row.published_to).format("MMM DD, YYYY"),
        };
      });
      ownClasses[id].interaction = interactionData;
    }

    this.setState((s0) => ({
      selectedOwnClassId: s0.selectedOwnClassId === id ? null : id,
      ownClasses,
    }));
  };

  renderSummaries = (ownClasses) => {
    const ownClassesArr = Object.values(ownClasses);
    const { isOpen } = this.state;
    if (ownClassesArr.length < 1) {
      return "";
    }
    return (
      <React.Fragment>
        {ownClassesArr.map((c, i) => {
          return (
            <CardClass
              title={c.className}
              key={i}
              isExpanded={isOpen}
              data={ownClassesArr}
              onClick={() => this.handleClickOwnClass(c.id)}
              onDownloadClick={this.props.ctx_user.user.reportType === "Jasper" ? this.handleJasperOwnClassDownload : this.handlePdfOwnClassDownload}
              classid={c.id}
            />
          );
        })}
      </React.Fragment>
    );
  };
  handleJasperOwnClassDownload = (e, c) => {
    e.stopPropagation();
    this.props.ctx_api
      .privateRequest({
        cmd: "get_report_own_class",

        args: {
          // publishid: this.props.entity.id,
          classid: c,
          orgid: this.props.ctx_user.user.organizationId,
          acadyear: this.props.ctx_user.user.acadYearId,
        },
      })
      .then(({ rsp }) => {
        this.downloadUrl = this.renderLink(rsp);
      })
      .catch(this.handleFetchFailure);
    // .finally(this.finalizeExport);
  };
  
  handlePdfOwnClassDownload = (e, c) => {
    e.stopPropagation()
    this.props.ctx_api
      .privateRequest({
        cmd: "get_own_class_progress_report",

        args: {
          classid: c,
          orgid: this.props.ctx_user.user.organizationId,
          acadyearid: this.props.ctx_user.user.acadYearId,
        },
      })
      .then(({ rsp }) => {
        this.generateNewPDF(rsp[0].test_data);
      })
      .catch(this.handleFetchFailure);
    // .finally(this.finalizeExport);
  };

  generateNewPDF = jsonData => {
    const headers = ['Sl. No', 'Course Name', 'Teacher Name', 'Progress %', 'Test %'];
    this.doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "landscape" });

    let yPos1 = 15;
    this.doc.text(`${this.props.ctx_labels.singular.class} Progress Report`, this.doc.internal.pageSize.width / 2, yPos1, { align: "center" });
    yPos1 += 5;

    const titleWidth = this.doc.getTextWidth("Class Progress Report") * 10;
    const underlineX = (this.doc.internal.pageSize.width - titleWidth) / 2;
    this.doc.setLineWidth(0.5);
    this.doc.line(underlineX, yPos1, underlineX + titleWidth, yPos1);

    let yPos = 33;
    const marginX = 30;
    const slNoColumnWidth = 15;
    const columnWidths = [slNoColumnWidth, 80, 60, 45, 45]; // Adjusted column widths for each column

    this.doc.setTextColor(0);
    this.doc.setFontSize(10);
    this.doc.text(`${this.props.ctx_labels.singular.class}     :  ${jsonData[0].class_name}`, marginX, yPos); // Draw Class Name
    yPos += 10;

    headers.forEach((header, index) => {
        this.doc.setDrawColor(0);
        this.doc.setFillColor(200);
        this.doc.rect(marginX + columnWidths.slice(0, index).reduce((acc, width) => acc + width, 0), yPos, columnWidths[index], 15, 'FD'); // Use adjusted column widths
        this.doc.setTextColor(0);
        this.doc.setFontSize(10);
        const headerX = marginX + columnWidths.slice(0, index).reduce((acc, width) => acc + width, 0) + columnWidths[index] / 2; // Adjusted X position calculation
        const headerY = yPos + 10;
        this.doc.text(header, headerX, headerY, { align: "center" });
    });

    yPos += 15;

    jsonData.forEach((row, rowIndex) => {
        const remainingSpace = this.doc.internal.pageSize.height - yPos - 20;
        const requiredSpace = 10;

        if (remainingSpace < requiredSpace) {
            this.doc.addPage();
            yPos = 20;
        }

        const { class_name, ...rowData } = row;
        Object.entries(rowData).forEach(([key, cell], colIndex) => {
            if (colIndex === 0) {
                this.doc.setDrawColor(0);
                this.doc.setFillColor(255);
                this.doc.rect(marginX, yPos, columnWidths[0], 10, 'FD'); // Use adjusted column widths
                this.doc.setTextColor(0);
                this.doc.setFontSize(8);
                this.doc.text((rowIndex + 1).toString(), marginX + columnWidths[0] / 2, yPos + 6, { align: "center" });
            }
            this.doc.setDrawColor(0);
            this.doc.setFillColor(255);
            this.doc.rect(marginX + columnWidths.slice(0, colIndex + 1).reduce((acc, width) => acc + width, 0), yPos, columnWidths[colIndex + 1], 10, 'FD'); // Use adjusted column widths
            this.doc.setFontSize(8);

            const alignment = (colIndex === 0 || colIndex === 1) ? { align: "left" } : { align: "center" };
            const textX = (colIndex === 0 || colIndex === 1) ? marginX + columnWidths.slice(0, colIndex + 1).reduce((acc, width) => acc + width, 0) + 2 : marginX + columnWidths.slice(0, colIndex + 1).reduce((acc, width) => acc + width, 0) + columnWidths[colIndex + 1] / 2;

            this.doc.text(cell ? cell.toString() : '0', textX, yPos + 6, alignment);
        });
        yPos += 10;
    });

    this.doc.save('class_report.pdf');
  };

  handlePageChange = page => {
    this.setState({ page: page, searching:true }, () => {
      this.loadClassSubjectData();
    });
  };

  renderTableClass = () => {
    const { selectedOwnClassId, ownClasses } = this.state;
    const ownClassesArr = Object.values(ownClasses);
    if (this.props.ctx_user.user.type === 2) {
      return (
        selectedOwnClassId && (
          <TableClass
            data={ownClasses[+selectedOwnClassId]}
            title={ownClassesArr[0].className}
            addRedirection={this.props.addRedirection}
            onDownloadClick={this.props.ctx_user.user.reportType === "Jasper" ? this.handleDownloadClick : this.handlePdfDownloadClick}
          />
        )
      );
    }

    return (
      <TableClass
        data={this.state.classData}
        onDownloadClick={this.props.ctx_user.user.reportType === "Jasper" ? this.handleDownloadClick : this.handlePdfDownloadClick}
        addRedirection={this.props.addRedirection}
        classData = {this.props.location.data}
        isFromClassPerformance = {this.props.location.state?.fromClassPerformance || this.props.location?.data?.fromClassPerformance }
      />
    );
  };

  renderTableSubject = () => {
    const { classSubjects } = this.state;
    // const { classSubjects, sortColumn, sortDirection } = this.state;
    const classSubjectsArr = Object.values(classSubjects);
    // if (classSubjectsArr.length < 1) {
    //   // this.setState({ searching : false })
    //   return (
    //     <>
    //      <TableSubjects searching={this.state.searching}/>
    //     </>
    //   );
    // }
    return (
      <TableSubjects
        data={classSubjectsArr}
        onMenuChange={this.props.onMenuChange}
        onDownloadClick={this.props.ctx_user.user.reportType === "Jasper" ? this.handleDownloadClick : this.handlePdfDownloadClick}
        totalCount={this.state.totalCount}
        searching={this.state.searching}
        onPageChange={this.handlePageChange}
        expiredCourses={this.expiredCourses}
        filterChange={this.filterChange}
        isClass
        addRedirection={this.props.addRedirection}
      />
    );
  };

  renderTrainerScreen = () => {
    const { ownClasses, isOpen } = this.state;
    const ownClassesArr = Object.values(ownClasses);
    return (
      <>
        <Breadcrumb
          list={[
            {
              title: `${this.props.ctx_labels.singular.my} ${this.props.ctx_labels.plural.class}`,
              current: true,
            },
          ]}
        />

        <div className="mb-2"></div>

        { this.state.classSubjects && this.renderTableSubject()}
        {ownClassesArr.length < 1 ? (
          ""
        ) : (
          <PageTitle>{this.props.ctx_labels.singular.my} {this.props.ctx_labels.plural.class}</PageTitle>
         
        )}
        <Row>
          <Col xl={3} lg={4} sm={6}>
            {this.renderSummaries(ownClasses)}
          </Col>
        </Row>

        {isOpen && this.renderTableClass()}
      </>
    );
  };


  handleDownloadClick = (e, c) => {
    e.stopPropagation();
    this.props.ctx_api
      .privateRequest({
        cmd: "get_report_class_subject",
        args: {
          // publishid: this.props.entity.id,
          //curriculumid: c.curriculum_id,
          classid: c.class_id,
          coursepublishid: c.course_publish_id,
          orgid: this.props.ctx_user.user.organizationId,
          acadyearid: this.props.ctx_user.user.acadYearId,
        },
      })
      .then(async ({ rsp }) => {
        this.downloadUrl = await this.renderLink(rsp);
      })
      .catch(this.handleFetchFailure);
    // .finally(this.finalizeExport);
  };


  handlePdfDownloadClick = (e,c) => {
    e.stopPropagation()
    this.props.ctx_api
      .privateRequest({
        cmd: "get_subject_progress_report",

        args: {
          classId: c.class_id,
          coursePublishId: c.course_publish_id,
          orgId: this.props.ctx_user.user.organizationId,
          acadyearid: this.props.ctx_user.user.acadYearId,
        },
      })
      .then(({ rsp }) => {
        this.generatePDF(rsp[0].test_data);
      })
      .catch(this.handleFetchFailure);
    // .finally(this.finalizeExport);
  };

  generatePDF = jsonData => {

    const headers = ['Sl. No', 'Name', 'Completion Date', 'Progress %']; 
    this.doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "portrait" });
    
    let yPos1 = 15;
    this.doc.text(`${this.props.ctx_labels.singular.subject} Progress Report`, this.doc.internal.pageSize.width / 2, yPos1, { align: "center" });
    yPos1 += 5;
    
    const titleWidth = this.doc.getTextWidth("Subject Progress Report") * 10;
    const underlineX = (this.doc.internal.pageSize.width - titleWidth) / 2;
    this.doc.setLineWidth(0.5);
    this.doc.line(underlineX, yPos1, underlineX + titleWidth, yPos1); 

    let yPos = 33;
    const marginX = 20;
    const slNoColumnWidth = 15;
    const columnWidth = (this.doc.internal.pageSize.width - (marginX * 2) - slNoColumnWidth) / (headers.length - 1); // Adjusting the column width for the remaining columns

    let headersDrawn = false; 

    this.doc.setTextColor(0);
    this.doc.setFontSize(10);
    this.doc.text(`${this.props.ctx_labels.singular.class}     :  ${jsonData[0].class_name}`, marginX, yPos); // Draw Class Name
    yPos += 10;
    this.doc.text(`${this.props.ctx_labels.singular.course}  :  ${jsonData[0].course_name}`, marginX, yPos); // Draw Course Name
    yPos += 15;

    if (!headersDrawn) {
      headers.forEach((header, index) => {
        if (index === 0) {
          this.doc.setDrawColor(0);
          this.doc.setFillColor(200);
          this.doc.rect(marginX, yPos, slNoColumnWidth, 15, 'FD');
          this.doc.setTextColor(0);
          this.doc.setFontSize(10);
          const headerX = marginX + slNoColumnWidth / 2;
          const headerY = yPos + 10;
          this.doc.text(header, headerX, headerY, { align: "center" });
        } else {
          this.doc.setDrawColor(0);
          this.doc.setFillColor(200);
          this.doc.rect(marginX + slNoColumnWidth + (columnWidth * (index - 1)), yPos, columnWidth, 15, 'FD'); // Draw filled rectangle with borders for header
          this.doc.setTextColor(0);
          this.doc.setFontSize(10);
          const headerX = marginX + slNoColumnWidth + (columnWidth * (index - 1)) + columnWidth / 2; // Calculate X position to center-align header
          const headerY = yPos + 10;
          this.doc.text(header, headerX, headerY, { align: "center" });
        }
      });
      yPos += 15;
      headersDrawn = true;
    }

    jsonData.forEach((row, rowIndex) => {
      const remainingSpace = this.doc.internal.pageSize.height - yPos - 20;
      const requiredSpace = 10;

      if (remainingSpace < requiredSpace) {
        this.doc.addPage();
        yPos = 20;
      }

      const { class_name, course_name, ...rowData } = row;
      Object.entries(rowData).forEach(([key, cell], colIndex) => {
        if (colIndex === 0) {
          this.doc.setDrawColor(0);
          this.doc.setFillColor(255);
          this.doc.rect(marginX, yPos, slNoColumnWidth, 10, 'FD');
          this.doc.setTextColor(0);
          this.doc.setFontSize(8);
          this.doc.text((rowIndex + 1).toString(), marginX + slNoColumnWidth / 2, yPos + 6, { align: "center" });
        }
        if (cell === null) {
          if (key === 'progress_percentage') {
            cell = 'Yet to start';
          } else {
            cell = 'N/A';
          }
        } else if (cell === 0 && key === 'progress_percentage') {
          cell = '0';
        }

        this.doc.setDrawColor(0);
        this.doc.setFillColor(255);
        this.doc.rect(marginX + slNoColumnWidth + (columnWidth * colIndex), yPos, columnWidth, 10, 'FD');
        this.doc.setFontSize(8);
        this.doc.text(cell ? cell.toString() : 'N/A', marginX + slNoColumnWidth + (columnWidth * colIndex) + columnWidth / 2, yPos + 6, { align: "center" });
      });
      yPos += 10;
    });
    this.doc.save('subject_report.pdf');
  };
  
  getNameLabel = (props) =>
    this.props.ctx_labels.singular[props.name] || props.name;

  renderAdminScreen = () => {
    const { ownClasses, isOpen } = this.state;
    const { location } = this.props;
    const isFromClassPerformance = location.state ? location.state?.fromClassPerformance : this.props.location?.data?.fromClassPerformance ? this.props.location.data.fromClassPerformance : null;

    // Define the breadcrumb based on the condition
    const breadcrumbList = [
      !isFromClassPerformance && {
        title: util.capitalizeWord(
          this.getNameLabel({
            name:
              this.props.location.alternateEntry ||
                this.props.location.data
                ? `${this.props.ctx_labels.singular.classlist}`
                : null,
          })
        ),
        link:
          this.props.location.alternateEntry || this.props.location.data
            ? config.ROUTES.classList
            : null,
      },
      {
        title: `${location.alternateEntry?.name ||
          location.data?.className ||
          location.data?.name || 
          location.data?.class_name
          }`,
        current: true,
      },
    ].filter(Boolean);

    return (
      <>
        <Breadcrumb list={breadcrumbList} />
        {this.renderTableClass()}
      </>
    );
  };

  handleFetchFailure = (err) => {
    this.props.ctx_window.alert(messages.mkFailureErrorAlert());
    console.log(`fetch error: ${err.message}`);
  };

  renderLink = async (rsp) => {
    const link = document.createElement("a");
    link.id = "render-link";
    link.href = `data:application/octet-stream;base64,${rsp.data}`;
    link.download = rsp.name + "." + "pdf";
    link.click();
  };
  render = () => {
    return (
      <MainContainer>
        {this.props.ctx_user.user.type === 2
          ? this.renderTrainerScreen()
          : this.renderAdminScreen()}
      </MainContainer>
    );
  };
}
export default withWindowContext(
  withApiContext(withUserContext(withLabelsContext(withRouter(MyClasses))))
);
